import MiddleBanner from "../middle-banner/middle-banner.vue";
import Card from "./card/card.vue";

//Data
import aboutUsDataSrc from "../../data/about-us-data";

export default {
  components: { MiddleBanner, Card },
  props: ["idNav"],
  data() {
    return {
      aboutUsData: aboutUsDataSrc,
    };
  },
};
